// extracted by mini-css-extract-plugin
module.exports = {"box":"record-screen_box__gfgS7"};